import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button } from "../components/kit";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");
  const { refreshUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setStatus("error");
      setMessage("Missing confirmation token. Please use the link from your email.");
      return;
    }
    api
      .post("/auth/verify-email-change", { token })
      .then(async (r) => {
        setStatus("success");
        setMessage(r.data?.email ? `Your account email is now ${r.data.email}.` : "Your email has been updated.");
        try { await refreshUser(); } catch (e) { /* not logged in on this device — fine */ }
      })
      .catch((e) => {
        setStatus("error");
        setMessage(formatApiErrorDetail(e.response?.data?.detail) || "This link is invalid or has expired.");
      });
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthLayout title="Confirm your email" subtitle="Finishing your email change." testId="verify-email-page">
      {status === "loading" && (
        <div data-testid="verify-loading" style={infoStyle}>Confirming your new email…</div>
      )}
      {status === "success" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
          <div data-testid="verify-success" style={okStyle}>{message}</div>
          <Link to="/dashboard"><Button full size="lg" data-testid="verify-dashboard-btn">Go to my dashboard</Button></Link>
          <Link to="/login" data-testid="verify-login-link" style={linkStyle}>Sign in</Link>
        </div>
      )}
      {status === "error" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
          <div data-testid="verify-error" style={errStyle}>{message}</div>
          <Link to="/account" data-testid="verify-back-link" style={linkStyle}>← Back to account settings</Link>
        </div>
      )}
    </AuthLayout>
  );
}

const infoStyle = { padding: "var(--space-4)", borderRadius: "var(--radius-md)", background: "var(--surface-brand-wash)", color: "var(--buktu-green-deep)", font: "var(--type-body-sm)" };
const okStyle = { padding: "var(--space-4)", borderRadius: "var(--radius-md)", background: "var(--surface-brand-wash)", color: "var(--buktu-green-deep)", font: "var(--type-body-sm)" };
const errStyle = { padding: "var(--space-3) var(--space-4)", borderRadius: "var(--radius-md)", background: "var(--status-risk-soft)", color: "#8a2a1a", font: "var(--type-body-sm)", fontSize: 13 };
const linkStyle = { color: "var(--text-link)", font: "var(--type-body-sm)", textAlign: "center" };
